import React, {useEffect, useState} from "react";
import {Box, IconButton, ListItemIcon, ListItemText, Menu, MenuItem} from "@mui/material";
import {useTranslation} from "react-i18next";
import {useApolloClient} from "@apollo/client";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPhonePlus} from "@fortawesome/pro-solid-svg-icons";

const CardMenuButton = ({ children, menuItems, filterItems }) => {

	const {t} = useTranslation();
	const [anchorEl, setAnchorEl] = useState(null);
	const open = Boolean(anchorEl);

	const handleClose = () => {
		setAnchorEl(null);
	};

	return (
		<Box>
			<IconButton onClick={(e) => {
				setAnchorEl(e.currentTarget);
			}}
			aria-controls={open ? "account-menu" : undefined}
			aria-haspopup="true"
			aria-expanded={open ? "true" : undefined}
			>
				{children}
			</IconButton>
			<Menu
				aria-labelledby="menu"
				anchorEl={anchorEl}
				open={open}
				onClose={handleClose}
				sx={{padding: 0}}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "right"
				}}
				transformOrigin={{
					vertical: "top",
					horizontal: "right"
				}}
			>
				{ filterItems &&
					filterItems.map((filterItem, i) => (
						<MenuItem
							key={i}
							onClick={() => {
								filterItem.cb();
								handleClose();
							}}
						>
							{ filterItem.icon &&
								<ListItemIcon sx={{justifyContent: "center", pr: 1}}>
									<FontAwesomeIcon icon={filterItem.icon} size={"lg"} fixedWidth/>
								</ListItemIcon>
							}
							<ListItemText
								primary={t(filterItem.label)}
								slotProps={{
									primary: {
										variant: "h5"
									}
								}}
							>

							</ListItemText>
						</MenuItem>
					))
				}
				{ menuItems &&
					menuItems.map((item, index) => (
						!item.hide &&
						<MenuItem
							key={index}
							sx={ index === 0 ? {paddingTop: "0px", px: 0} : {paddingTop: "10px", px: 0}}
							onClick={() => {
								if (item.function !== undefined) {
									item.function();
								}
								handleClose();
							}}
						>
							<ListItemIcon sx={{justifyContent: "center", pr: 1}}>
								<FontAwesomeIcon icon={item.icon} size={"lg"} fixedWidth/>
							</ListItemIcon>
							<ListItemText
								primary={t(item.primaryText)}
								secondary={t(item.secondaryText)}
								slotProps={{
									primary: {
										variant: "h5"
									}
								}}
							>

							</ListItemText>
						</MenuItem>
					))
				}
			</Menu>
		</Box>
	);
};
export default CardMenuButton;
